import { motion } from 'framer-motion';
import React, { useState } from 'react';

const dotVariants = {
  normal: {
    opacity: 1
  },
  animate: (custom) => ({
    opacity: [1, 0, 0, 1, 1, 0, 0, 1],
    transition: {
      opacity: {
        times: [
          0,
          0.1,
          0.1 + custom * 0.1,
          0.1 + custom * 0.1 + 0.1,
          0.5,
          0.6,
          0.6 + custom * 0.1,
          0.6 + custom * 0.1 + 0.1
        ],
        duration: 1.5
      }
    }
  })
};

const AnimatedMessageCircleMoreIcon = ({ size = 28, className = '', bubbleColor = null, ...rest }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.5rem',
        borderRadius: '0.375rem',
        transition: 'background-color 0.2s'
      }}
      className={className}
      {...rest}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"
          fill={bubbleColor || 'none'}
        />
        <motion.path
          d="M8 12h.01"
          initial="normal"
          animate={hovered ? 'animate' : 'normal'}
          variants={dotVariants}
          custom={0}
        />
        <motion.path
          d="M12 12h.01"
          initial="normal"
          animate={hovered ? 'animate' : 'normal'}
          variants={dotVariants}
          custom={1}
        />
        <motion.path
          d="M16 12h.01"
          initial="normal"
          animate={hovered ? 'animate' : 'normal'}
          variants={dotVariants}
          custom={2}
        />
      </svg>
    </div>
  );
};

export default AnimatedMessageCircleMoreIcon;
